import Apify from '@wetransfer/transfer/modules/apify';

export default Apify({
  createSession: {
    path: '/api/v4/auth/session',
    method: 'POST',
  },

  signup: {
    path: '/api/v4/users/signup',
    method: 'POST',
  },

  sync: {
    path: '/api/v4/auth/sync',
    method: 'POST',
  },

  completePayment: {
    path: '/api/v4/users/complete-payment',
    method: 'POST',
  },

  updatePaymentMethod: {
    path: '/api/v4/users/payment-methods',
    method: 'PUT',
  },

  validate: {
    path: '/api/v4/users/validate',
    pathExt: true,
    method: 'POST',
  },

  getCurrentUser: {
    path: '/api/v4/auth/session',
  },

  updateUser: {
    path: '/api/v4/users',
    method: 'PUT',
  },

  updateUserLanguage: {
    path: '/api/v4/users/language',
    method: 'PUT',
  },

  unsubscribeUserOnboarding: {
    path: '/api/v4/users/pm-onboarding-unsubscribe',
    pathExt: true,
    method: 'POST',
  },

  unsubscribeLinkTransfer: {
    path: '/api/v4/users/link-transfer-download-notification-unsubscribe',
    method: 'POST',
  },

  updatePassword: {
    path: '/api/v4/users/password',
    method: 'PUT',
  },

  requestPasswordReset: {
    path: '/api/v4/auth/password',
    method: 'POST',
  },

  triggerPasswordReset: {
    path: '/api/v4/users/trigger-password-reset',
    method: 'POST',
  },

  resetPassword: {
    path: '/api/v4/auth/password',
    method: 'PUT',
  },

  getContacts: {
    path: '/api/v4/contacts',
    method: 'GET',
  },

  addContact: {
    path: '/api/v4/contacts',
    method: 'POST',
  },

  editContact: {
    path: '/api/v4/contacts/{contactId}',
    pathExt: true,
    method: 'PUT',
  },

  removeContact: {
    path: '/api/v4/contacts/batch',
    method: 'POST',
  },

  assignTransfer: {
    path: '/api/v4/users/assign-transfer',
    method: 'POST',
  },

  uploadPicture: {
    path: '/api/v4/images/thumbs/profile_pictures',
    method: 'POST',
  },

  verifyAccountEmail: {
    path: '/api/v4/users/account-verification',
    method: 'POST',
  },

  resendVerifyAccountEmail: {
    path: '/api/v4/users/account-verification/resend',
    method: 'POST',
  },

  setUserAsOnboarded: {
    path: '/api/v4/users/onboarded',
    method: 'POST',
  },

  generateRecoveryCodes: {
    path: '/api/v4/users/two-factor-authentication/otp/generate-backup-tokens',
    method: 'POST',
  },

  createTwoFactorAuthenticationCode: {
    path: '/api/v4/users/two-factor-authentication/otp/create',
    method: 'POST',
  },

  retrieveEnableTwoFactorRedirectUrl: {
    path: '/api/v4/users/two-factor-authentication/sso/enroll-mfa-ticket',
    method: 'GET',
  },

  disableTwoFactorAuthentication: {
    path: '/api/v4/users/two-factor-authentication/{type}/disable',
    pathExt: true,
    method: 'POST',
  },

  enableTwoFactorAuthentication: {
    path: '/api/v4/users/two-factor-authentication/otp/enable',
    method: 'POST',
  },

  unsubscribeFromExpirationReminders: {
    path: '/api/v4/users/unsubscribe-expiration-reminders',
    method: 'POST',
  },

  setUserOccupation: {
    path: '/api/v4/users/add-user-tag',
    method: 'POST',
  },

  getUserOccupation: {
    path: '/api/v4/users/user-tag',
    method: 'GET',
  },

  updateUserDataOptIn: {
    path: '/api/v4/users/user-tag-update',
    method: 'PUT',
  },

  setMarketingEmailPreference: {
    path: '/api/v4/users/email-marketing-preference',
    method: 'POST',
  },

  setOnboardingStepValue: {
    path: '/api/v4/users/add-onboarding-event',
    method: 'POST',
  },

  getOnboardingStepValue: {
    path: '/api/v4/users/onboarding-events',
    method: 'GET',
  },

  getChannelTransferSizeLimit: {
    path: '/api/v4/channels/{name}',
    pathExt: true,
    method: 'GET',
  },
});
